import CustomerDto from "../components/Common/dtos/CustomerDto";
import { QueryOptions } from "../components/Common/useQuery";
import useUserOrEmployeeQuery from "../components/Common/useUserOrEmployeeQuery";
import { useUserOrKaEmployee } from "../components/UserAccess/useUserOrKaEmployee";

const useGetCustomers = (options?: QueryOptions<CustomerDto[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();

  return useUserOrEmployeeQuery<CustomerDto[]>(
    { path: `/api/businesses/${selectedBusiness?.id}/customers` },
    options);
}

export default useGetCustomers;